<h2 mat-dialog-title>{{'COMMON.DELETE' | translate}} - {{deletableItemTitle}}</h2>

<mat-dialog-content>
  <div class="row">
    <div class="col-12">
      {{'QUESTIONS.ARE_YOU_SURE_DELETE' | translate}}
    </div>

  </div>

</mat-dialog-content>

<app-modal-footer [submitButtonTranslateKey]="'COMMON.DELETE'" (submit)="delete()" (close)="close()"></app-modal-footer>
